import { formatDate } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NumberCardComponent } from '@swimlane/ngx-charts';
import { Subscription } from 'rxjs';
import { ClienteAutocompleteComponent } from 'src/app/@shared/components/combos/cliente/cliente-autocomplete/cliente-autocomplete.component';
import { PainelControleRiscoToalizadoresRequest, PainelControleRiscoTotalizadoresResponse } from 'src/app/@shared/models/painel-risco.model';
import { FilialService } from 'src/app/services/filial/filial.service';
import { PainelControleRiscoService } from 'src/app/services/painel-controle-risco/painel-controle-risco.service';
import { ProdutoService } from 'src/app/services/produto/produto.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { PainelControleRiscoGridDetalhesComponent } from './grid-detalhes/painel-controle-risco-grid-detalhes.component';

@Component({
  selector: 'app-painel-controle-risco',
  templateUrl: './painel-controle-risco.component.html',
  styleUrls: ['./painel-controle-risco.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PainelControleRiscoComponent implements OnInit {

  private subscriptions: Array<Subscription> = [];

  public usuario = StorageService.getPerfilUsuario();
  isLoading: boolean;
  gridFilters: any;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(ClienteAutocompleteComponent, { static: false }) comboCliente;
  @ViewChild('cards') cardsRef: NumberCardComponent;
  @ViewChild('gridDetalhes') gridDetalhes: PainelControleRiscoGridDetalhesComponent;

  filterForm = new FormGroup({
    fromDate: new FormControl('', Validators.required),
    toDate: new FormControl('', Validators.required),
    filialFormControl: new FormControl({value: '', disabled: Number(this.usuario.perfilacessotipo) === 3}),
    clienteFormControl: new FormControl(),
    produtosFormControl: new FormControl({value: '', disabled: true}),
  });
  get fromDate() { return this.filterForm.get('fromDate').value; }
  get toDate() { return this.filterForm.get('toDate').value; }
  get clienteFormControl() { return this.filterForm.get('clienteFormControl').value; }

  clientes = [];
  filiais = [];
  filial;
  clienteId;
  produto;
  produtos = [];
  public paging = { index: 0, size: 10, length: 0 };

  mensagemFiltro: string;
  totalizadores: any;

  colorScheme: any = { domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5'] };

  filtrarRecepcaoLogica: boolean = false;
  filtrarRecepcaoFisica: boolean = false;
  filtrarEmTransferencia: boolean = false;
  filtrarEmRota: boolean = false;
  filtrarEntregue: boolean = false;
  filtrarTentativaEntrega: boolean = false;
  filtrarDevolucao: boolean = false;

  indicadoresTexts: any[] = [
    "Recepção lógica",
    "Recepção física",
    "Em transferência",
    "Em Rota",
    "Entregue",
    "Tentativa de Entrega",
    "Reagendar / Devolução",
  ];

  indicadores: any[] = [
    { "name": this.indicadoresTexts[0], "value": 0, "extra": "filtrarRecepcaoLogica" },
    { "name": this.indicadoresTexts[1], "value": 0, "extra": "filtrarRecepcaoFisica" },
    { "name": this.indicadoresTexts[2], "value": 0, "extra": "filtrarEmTransferencia" },
    { "name": this.indicadoresTexts[3], "value": 0, "extra": "filtrarEmRota" },
    { "name": this.indicadoresTexts[4], "value": 0, "extra": "filtrarEntregue" },
    { "name": this.indicadoresTexts[5], "value": 0, "extra": "filtrarTentativaEntrega" },
    { "name": this.indicadoresTexts[6], "value": 0, "extra": "filtrarDevolucao" }
  ];

  constructor(
    private painelControleRiscoService: PainelControleRiscoService,
    public snackBar: MatSnackBar,
    private filialService: FilialService,
    private produtoService: ProdutoService
  ) { }

  ngOnInit() {
    this.iniciarDatas();
    this.listarFilial();

    this.filterForm.get('clienteFormControl').valueChanges.subscribe(
      (value: string) => {
        if (!value || value.length === 0) {
          this.filterForm.controls.produtosFormControl.disable();
          this.produtos = [];
          this.produto = null;
          this.clienteId = null;
          this.filterForm.get('produtosFormControl').setValue(null);
          this.filterForm.get('produtosFormControl').updateValueAndValidity();
        }
      });
  }

  iniciarDatas() {
    const filtroFim = new Date();
    const filtroInicio = new Date(filtroFim);
    filtroInicio.setDate(filtroInicio.getDate() - 7);
    this.filterForm.get('fromDate').setValue(filtroInicio.toString());
    this.filterForm.get('toDate').setValue(filtroFim.toString());
  }

  clearFields() {
    this.filtrarEmRota = false;
    this.filtrarEmTransferencia = false;
    this.filtrarRecepcaoFisica = false;
    this.filtrarEntregue = false;
    this.filtrarRecepcaoLogica = false;
    this.filtrarDevolucao = false;
    this.filtrarTentativaEntrega = false;
    this.filterForm.reset();
    this.clienteId = null;
    this.totalizadores = null;
    this.gridDetalhes.dataSource = null;
    this.iniciarDatas();
    this.filterForm.updateValueAndValidity();
    this.verificaProduto();
  }

  selecionarRelatorioNRTConsultarEtapas() {
    this.filtrarEmRota = false;
    this.filtrarEmTransferencia = false;
    this.filtrarRecepcaoFisica = false;
    this.filtrarEntregue = false;
    this.filtrarRecepcaoLogica = false;
    this.filtrarDevolucao = false;
    this.filtrarTentativaEntrega = false;
    if (!this.validaFiltros()) {
      this.openSnackBar(this.mensagemFiltro, 'OK', 5000, 'warning-snackbar');
    } else {
      if (this.verificaData() > 7) {
        this.openSnackBar('O período não deve ser maior do que 7 dias!', 'OK', 5000, 'warning-snackbar');
      } else {
        this.totalizadores = null;
        this.gridDetalhes.filters = null;
        this.consultarTotalizadores();
      }
    }
  }

  atualizarGrid() {
    if (this.filtrarEmRota ||
      this.filtrarEmTransferencia ||
      this.filtrarRecepcaoFisica ||
      this.filtrarEntregue ||
      this.filtrarRecepcaoLogica ||
      this.filtrarDevolucao ||
      this.filtrarTentativaEntrega) {

      this.gridFilters = {
        dataInicio: this.fromDate ? formatDate(this.fromDate, "yyyy-MM-dd", 'en-US') : null,
        dataFim: this.toDate ? formatDate(this.toDate, "yyyy-MM-dd", 'en-US') : null,
        filialId: this.filial,
        clienteId: this.clienteId,
        produtoId: this.produto,
        recepcaoLogica: this.filtrarRecepcaoLogica,
        recepcaoFisica: this.filtrarRecepcaoFisica,
        emTransferencia: this.filtrarEmTransferencia,
        emRota: this.filtrarEmRota,
        entregue: this.filtrarEntregue,
        tentativaEntrega: this.filtrarTentativaEntrega,
        devolucao: this.filtrarDevolucao,
        paging: Object.assign(this.paging, { index: 0 }),
        paginaAtual: this.paging.index + 1,
        itensPorPagina: this.paging.size
      } as PainelControleRiscoToalizadoresRequest;
      this.gridDetalhes.dataSource = null;

    } else {
      this.gridFilters = null;
      this.gridDetalhes.dataSource = null;
    }
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

  listarFilial() {
    this.filialService.listarFilialDestino().subscribe(response => {
      if (response && response.length > 0) {
        this.filiais = response;
        if (this.usuario.perfilacessotipo == 3 || this.usuario.perfilacessotipo == 1) {
          this.filial = this.usuario.filialid;
        }
      }
    },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar('Erro ao carregar lista de filiais, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  verificaProduto() {
    if (this.clienteId) {
      this.filterForm.controls.produtosFormControl.enable();
    } else {
      this.filterForm.controls.produtosFormControl.disable();
      this.produtos = [];
      this.produto = null;
    }
  }

  verificaData() {
    var de = new Date(this.filterForm.get('fromDate').value);
    var ate = new Date(this.filterForm.get('toDate').value);
    const diffTime = Math.abs(ate.getTime() - de.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  }

  toggleIndicador(item) {
    this[item.extra] = !this[item.extra];
    this.atualizaIndicadoresSelecionados();
    this.atualizarGrid();
  }

  atualizaIndicadores() {
    if (this.totalizadores) {
      this.indicadores = [
        { "name": this.indicadoresTexts[0], "value": this.totalizadores.recepcaoLogica, "extra": "filtrarRecepcaoLogica" },
        { "name": this.indicadoresTexts[1], "value": this.totalizadores.recepcaoFisica, "extra": "filtrarRecepcaoFisica" },
        { "name": this.indicadoresTexts[2], "value": this.totalizadores.emTransferencia, "extra": "filtrarEmTransferencia" },
        { "name": this.indicadoresTexts[3], "value": this.totalizadores.emRota, "extra": "filtrarEmRota" },
        { "name": this.indicadoresTexts[4], "value": this.totalizadores.entregue, "extra": "filtrarEntregue" },
        { "name": this.indicadoresTexts[5], "value": this.totalizadores.tentativaEntrega, "extra": "filtrarTentativaEntrega" },
        { "name": this.indicadoresTexts[6], "value": this.totalizadores.devolucao, "extra": "filtrarDevolucao" }
      ];
    }
  }

  atualizaIndicadoresSelecionados() {
    if (this.indicadores) {
      for (let index = 0; index < this.indicadores.length; index++) {
        const ind = this.indicadores[index];
        const el = document.querySelectorAll("[ngx-charts-card]")[index];
        const checked = this[ind.extra];

        if (checked) el.classList.add("selected");
        else el.classList.remove("selected");
      }
    }
  }

  addDays(date, days) {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000;
    var result = new Date(date);
    return (new Date(result.setDate(result.getDate() + days) - tzoffset)).toISOString();
  }

  selecionarProdutos() {
    this.produtoService.selecionarProdutos(this.clienteId).subscribe(response => {
      this.produtos = response;
      this.verificaProduto();
    },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar('Ocorreu um erro ao consultar! Tente novamente ou entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  validaFiltros() {
    if (this.filterForm.get('fromDate').value == null || this.filterForm.get('toDate').value == null) {
      this.mensagemFiltro = 'Os filtros de data são obrigatórios!';
      return false;
    }
    return true;
  }

  reciverFeedback(respostaFilho) {
    this.clienteId = respostaFilho;

    if (respostaFilho) {
      this.selecionarProdutos();
    } else {
      this.produtos = [];
    }
  }

  consultarTotalizadores() {
    this.isLoading = true;

    this.filterForm.controls.produtosFormControl.disable();
    Object.keys(this.filterForm.controls).forEach((control: string) => {
      if (control !== 'produtosFormControl') {
        const typedControl: AbstractControl = this.filterForm.controls[control];
        typedControl.disable();
      }
    });

    var obj = {
      dataInicio: this.fromDate ? formatDate(this.fromDate, "yyyy-MM-dd", 'en-US') : null,
      dataFim: this.toDate ? formatDate(this.toDate, "yyyy-MM-dd", 'en-US') : null,
      clienteId: this.clienteId,
      filialId: this.filial,
      produtoId: this.produto,
    } as PainelControleRiscoToalizadoresRequest

    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });

    this.subscriptions.push(
      this.painelControleRiscoService.consultarTotalizadores(obj).subscribe(
        (response: PainelControleRiscoTotalizadoresResponse[]) => {
          this.totalizadores = response;
          this.atualizaIndicadores();
          this.atualizarGrid();
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.openSnackBar('Ocorreu um erro ao consultar! Tente novamente ou entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
        },
        () => {
          Object.keys(this.filterForm.controls).forEach((control: string) => {
            if (control !== 'produtosFormControl') {
              const typedControl: AbstractControl = this.filterForm.controls[control];
              typedControl.enable();
            }
          });
          this.clienteId && (this.filterForm.controls.produtosFormControl.enable());
          this.isLoading = false
        }
      ));
  }
}
